import { AgreementContainer, AgreementPaper, AgreementContent, AgreementScrollToTop } from "../AgreementLayout";
import { kvkkRemoteHealthInfoHtml } from "../../../constants/agreements/remoteHealthInformationTexts";

const KvkkRemoteHealthInfo = () => {
    return (
        <AgreementContainer sx={{ py: 4 }}>
            <AgreementScrollToTop />
            <AgreementPaper elevation={0} sx={{ border: "1px solid", borderColor: "divider" }}>
                <AgreementContent dangerouslySetInnerHTML={{ __html: kvkkRemoteHealthInfoHtml }} />
            </AgreementPaper>
        </AgreementContainer>
    );
};

export default KvkkRemoteHealthInfo;
